import type { ReportVideoData } from "@/client";

export type ReportReason = ReportVideoData["body"]["reason"];

export const REASON_LABELS: Record<ReportReason, string> = {
	sexual: "Sexual content",
	violent: "Violence or gore",
	hateful: "Hateful or harassing",
	minor_safety: "Involves a minor",
	illegal: "Illegal activity",
	spam: "Spam or misleading",
	other: "Something else",
};

export const REPORT_REASONS = (
	Object.entries(REASON_LABELS) as [ReportReason, string][]
).map(([value, label]) => ({ value, label }));
